import { render, staticRenderFns } from "./TriggerButton.vue?vue&type=template&id=ea04668a&scoped=true"
import script from "./TriggerButton.vue?vue&type=script&lang=js"
export * from "./TriggerButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea04668a",
  null
  
)

export default component.exports